module.exports = __webpack_public_path__ + "static/img/SourceSansPro-LightItalic.c254d4b.svg";